import PasswordField from '@components/v2/form/PasswordField/PasswordField';
import AuthPanel from '@components/v2/layout/AuthPanel/AuthPanel';
import Button from '@components/v2/ui/Button/Button';
import { Controller } from 'react-hook-form';
import LangEnum from '../../../../lang/LangEnum';
import PATHS from '../../../../routes/routes.const';
import { MIN_PASSWORD_LENGTH } from '../../../../utils/constants';
import { useTranslation } from '../../../translation/TranslationContext';
import useResetPasswordForm from './hooks/useResetPasswordForm';
import useResetPasswordPanelStyles from './resetPasswordPanel.styles';

const ResetPasswordPanel = () => {
  const { classes } = useResetPasswordPanelStyles();
  const { translate } = useTranslation();
  const { form, handleSubmit } = useResetPasswordForm();

  return (
    <AuthPanel>
      <form onSubmit={handleSubmit} className={classes.form}>
        <Controller
          name="password"
          control={form.control}
          render={({ field, fieldState }) => (
            <PasswordField
              {...field}
              autoComplete="new-password"
              label={translate(LangEnum.PROFILE_USER_FORM_NEW_PASSWORD)}
              error={!!fieldState.error}
              helperText={
                fieldState.error?.message ??
                translate(LangEnum.LOGIN_PASSWORD_INFO, { min: MIN_PASSWORD_LENGTH })
              }
            />
          )}
        />
        <div className={classes.actions}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            fullWidth
            loading={form.formState.isSubmitting}
          >
            {translate(LangEnum.PROFILE_RESET_PASSWORD)}
          </Button>
          <Button
            variant="text"
            color="secondary"
            size="large"
            fullWidth
            to={PATHS.public.login.path}
          >
            {translate(LangEnum.GLOBAL_GO_BACK_TO_LOGIN)}
          </Button>
        </div>
      </form>
    </AuthPanel>
  );
};

export default ResetPasswordPanel;
